/**
 * Get the username error hint text based on validation state
 * @param errorMessage - Form validation error message
 * @param availabilityError - API error from availability check
 * @param isAvailable - Whether the username is available (null = not checked yet)
 * @returns Error hint text or undefined if no error
 */
export function getUsernameHint(
    errorMessage: string | undefined,
    availabilityError: string | null,
    isAvailable: boolean | null
): string | undefined {
    if (errorMessage) return errorMessage;
    if (availabilityError) return availabilityError;
    if (isAvailable === false) return 'This username is already taken';
    return undefined;
}

/**
 * Check if username field should show error state
 * @param hasFormError - Whether form validation has an error
 * @param isAvailable - Whether the username is available (null = not checked yet)
 * @returns Whether to show error styling
 */
export function hasUsernameError(hasFormError: boolean, isAvailable: boolean | null): boolean {
    return hasFormError || isAvailable === false;
}
